import * as React from "react";
import { forwardRef } from "react";
const GaugeArrowLeftIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.885 8.494a8.67 8.67 0 0 1 12.026-.002c.046.029.09.063.13.104a.75.75 0 0 1 .103.129 8.67 8.67 0 0 1-.113 12.141.75.75 0 0 1-1.061 0 .73.73 0 0 1-.039-.042.77.77 0 0 1-.041-.038l-1.198-1.197a.75.75 0 1 1 1.061-1.061l.719.719a7.134 7.134 0 0 0 1.557-3.761h-1.062a.75.75 0 1 1 0-1.5h1.063a7.133 7.133 0 0 0-1.557-3.762l-.629.63a.75.75 0 0 1-1.061-1.061l.629-.63a7.142 7.142 0 0 0-3.795-1.562v.834a.75.75 0 1 1-1.5 0v-.826a7.132 7.132 0 0 0-3.729 1.554l3.422 3.422.052.057a2.29 2.29 0 0 1 1.055-.256 2.3 2.3 0 0 1 2.3 2.3 2.3 2.3 0 0 1-2.3 2.3 2.3 2.3 0 0 1-2.3-2.3 2.29 2.29 0 0 1 .216-.969.75.75 0 0 1-.083-.071L7.965 10.86l-.638-.637a7.136 7.136 0 0 0-1.556 3.762h.996a.75.75 0 1 1 0 1.5h-.996a7.133 7.133 0 0 0 1.557 3.762l.721-.72a.75.75 0 0 1 1.061 1.061l-1.197 1.197a.77.77 0 0 1-.06.053c-.008.008-.013.019-.021.027a.75.75 0 0 1-1.004.052l-.057-.052-.309-.322A8.67 8.67 0 0 1 6.659 8.72a.738.738 0 0 1 .226-.226zm6.032 5.392a.8.8 0 0 0-.8.8.8.8 0 0 0 .8.8.8.8 0 0 0 .8-.8.8.8 0 0 0-.8-.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.801 4.065a.75.75 0 0 1 .75.75v2.9a.75.75 0 0 1-.75.75H2.9a.75.75 0 1 1 0-1.5h1.052l-1.461-1.35a.75.75 0 0 1 1.018-1.102l1.542 1.423V4.815a.75.75 0 0 1 .75-.75z"
}));
const ForwardRef = forwardRef(GaugeArrowLeftIcon);
export default ForwardRef;